import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { AppModal } from "@/shared/Components";
import { setFormIsValid } from "@/pages/ContactsPage/slice";
import { blockingModalActions, blockingModalSelectors, BlockingModalType } from "../model";
import styles from "./styles.module.scss";

export const BlockingModal = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const options = useAppSelector(blockingModalSelectors.selectOptions);
  const visible = useAppSelector(blockingModalSelectors.selectIsVisible);
  const type = useAppSelector(blockingModalSelectors.selectType);
  const onCancel = useAppSelector(blockingModalSelectors.selectHandleCancel);

  const handleClose = () => {
    dispatch(blockingModalActions.setConfirmIsVisible({ open: false, handleCancel: undefined }));
    dispatch(setFormIsValid(true));
  };

  const handleCancel = () => {
    onCancel && onCancel();
    handleClose();
  };

  if (type === BlockingModalType.confirm) {
    return (
      <AppModal
        centered
        maskClosable={false}
        closable={false}
        open={visible}
        title={options.title}
        onOk={handleClose}
        onCancel={handleCancel}
        okText={t("common.getBack")}
        cancelText={t("common.leaveAnyway")}
        cancelButtonProps={{}}
      >
        <p className={styles["modal-content"]}>{t("contactsPage.incorrectModal")}</p>
      </AppModal>
    );
  }

  return (
    <AppModal
      centered
      maskClosable={false}
      closable={false}
      open={visible}
      title={options.title}
      footer={null}
    >
      {options.content}
    </AppModal>
  );
};
